import React from "react";
import "../css/user.css";
import { KillProcessStatus } from "../Utility/ProcessStatus/processStatusUtils";


function ProcessStatusItem({ id, type, status, IDD}) {
    return (
        <div className="user">
            <p className="textlink OutpuField"><b>Name:</b> {id}</p>
            <p className="textlink UserField"><b>Type:</b> {type}</p>
            <p className="textlink UserField"><b>Status:</b> {status}</p>
            <div>
                <button type="submit" className="button buttonUser dangerbutton" onClick={() => KillProcessStatus(IDD, id)}>
                    Stop process
                </button>
            </div>
        </div>
    );
}

export default ProcessStatusItem;

